const FORCE_TEXT_VARIANT = '\uFE0E';
const DOWN_POINTED_TRIANGLE = '\u25BC' + FORCE_TEXT_VARIANT;
const RIGHT_POINTED_TRIANGLE = '\u25B6' + FORCE_TEXT_VARIANT;
const CHECK_MARK = '\u2713' + FORCE_TEXT_VARIANT;
const BACKWARD_ARROW = '\u2190' + FORCE_TEXT_VARIANT;

export {
    DOWN_POINTED_TRIANGLE,
    RIGHT_POINTED_TRIANGLE,
    CHECK_MARK,
    BACKWARD_ARROW,
};
